import React, { ReactNode } from 'react';

interface FlowAdministrationProps {
  children: ReactNode;  // Explicitly define children as a prop
}

const FlowAdministration: React.FC<FlowAdministrationProps> = ({ children }) => {
  return <>{children}</>;
};

export default FlowAdministration;
